import React from 'react'

import 'project/polyfill'
import SeoContainer, {
  SeoContainerProps,
} from 'components/util/containers/SeoContainer'
import Strings from 'project/localisation'
import HoxtonMixLogo from 'components/icons/HoxtonMixLogo'
import { ItemListElements } from 'next-seo/lib/types'
import useWindowSize from 'components/util/useWindowSize'
import { legalStrings } from 'common/strings/legal-strings'
import PartnerHeroBanner from 'components/hero/PartnerHeroBanner'
import { NextPageWithLayout } from '../../types/nextPageWithLayout'
import PageContainer from 'components/util/containers/PageContainer'
import { Tenant } from 'common/tenant'
import { auHomeBreadcrumb } from 'components/util/containers/Breadcrumbs'
import LegalDocumentSection from 'components/sections/LegalDocumentSection'

export type PageType = {}
const Page: NextPageWithLayout<PageType> = () => {
  const size = useWindowSize()

  const seoProps: SeoContainerProps['seoProps'] = {
    description: legalStrings.seoTermsAndConditionsDescription,
    openGraph: {
      url: 'https://www.hoxtonmix.com/au/terms-and-conditions/',
    },
    title: `${legalStrings.seoTermsAndConditionsTitle} | HM Australia`,
  }
  const breadcrumb: ItemListElements[] = [
    auHomeBreadcrumb()[0],
    {
      item: 'https://www.hoxtonmix.com/au/terms-and-conditions/',
      name: `${Strings.termsAndConditions}`,
      position: 2,
    },
  ]
  return (
    <SeoContainer
      alternate={[
        { href: '/terms-and-conditions', lang: 'en-gb' },
        { href: '/au/terms-and-conditions', lang: 'en-au' },
      ]}
      breadcrumb={breadcrumb}
      seoProps={seoProps}
    >
      <main className={'overflow-hidden'}>
        <PartnerHeroBanner
          partnershipLogo={
            <HoxtonMixLogo
              className='mb-6 mb-lg-4'
              containerClassName='w-lg-85'
            />
          }
          title={
            <>
              Virtual Office Terms <br /> and Conditions
            </>
          }
          robotImage={{
            height: 876,
            src: '/images/new/au/robot-holding-mail.png',
            width: 680,
          }}
          imageContainerWidth={size.isLgOrHigher ? '43%' : '100%'}
          description=''
        />

        <div className='container'>
          <LegalDocumentSection
            title={legalStrings.termsAndConditionsTitle}
            subtitle={legalStrings.termsAndConditionsSubtitle}
            content={legalStrings.termsAndConditionsDescription}
            documentTitle={`${Strings.termsAndConditions}`}
            documentSize={466}
            documentPath={`/terms_and_conditions_au.pdf`}
            contentStyle={{
              maxWidth: 987,
            }}
          />
        </div>
      </main>
    </SeoContainer>
  )
}
Page.getLayout = (page: React.ReactNode) => (
  <PageContainer tenant={Tenant.AU}>{page}</PageContainer>
)
export default Page
